module.exports = __webpack_public_path__ + "static/img/bg-es.e0d3b485.png";